import {RouteContext} from "../../RouteContext";
import {useParams} from "react-router-dom";
import React, {useEffect, useState} from "react";
import {Button, Field, FieldProps, Image, Input, Label, Radio, RadioGroup, Spinner} from "@fluentui/react-components";
import {PlacePathFileValueObject} from "../../../../model/vo/content/place/PlacePathFileValueObject";
import {
    InputStringStatePair,
    StatePair,
    useError,
    useInputString,
    useStatePair,
    useUndefined
} from "../../../../type/States";
import {PlacePathFileIO} from "../../../../io/content/place/PlacePathFileIO";
import {PlacePathFileDataTransferObject} from "../../../../model/dto/content/place/PlacePathFileDataTransferObject";
import {Column, Row} from "../../common/Layout";
import {DataTransferObjectValidation, Types} from "../../../../type/Types";
import {Styles} from "../../common/Styles";
import {
    ShoppingPathJointFileDataTransferObject
} from "../../../../model/dto/content/ShoppingPathJointFileDataTransferObject";

export default function Edit(props: RouteContext) {
    const params = useParams<{ id: string }>()
    const itemState = useUndefined<PlacePathFileValueObject>()
    const itemErrorState = useError()

    useEffect(() => {
        if (params.id === undefined) {
            return
        }
        if (itemState.value !== undefined) {
            return
        }

        PlacePathFileIO.get(BigInt(params.id))
            .then(itemState.setDefinedValue)
            .catch(itemErrorState.setDefinedValue)
    }, [params.id, itemState.value])

    const item = itemState.value
    return <>
        <itemErrorState.Dialog {...props} />
        {item === undefined && <Spinner />}
        {item !== undefined && <>
            <EditPage
                {...props}
                item={item}></EditPage>
        </>}
    </>
}

type EditPageProps = RouteContext & {
    item: PlacePathFileValueObject
}

function EditPage(props: EditPageProps) {
    const styles = Styles.useEditorStyles()

    const [guideLineFile, setGuideLineFile] = useState<File | null>(null)
    const [previewUrl, setPreviewUrl] = useState<string>(props.item.fileUrl || '')
    const [guideLineType, setGuideLineType] = useState('url')

    useEffect(() => {
        console.log(guideLineFile)
        if (guideLineFile) {
            const preview = URL.createObjectURL(guideLineFile)
            setPreviewUrl(preview)
        }
        console.log(props.item)
    }, [guideLineFile])

    const inputStates: Record<keyof PlacePathFileDataTransferObject.Put, InputStringStatePair> = {
        placePathId: useInputString(Types.present(props.item.placePathId, '')),
        orderNumber: useInputString(Types.present(props.item.orderNumber, '')),
        fileName: useInputString(Types.present(props.item.fileName, '')),
        fileUrl: useInputString(Types.present(props.item.fileUrl, '')),
    }
    const inputValidationStates: Record<keyof PlacePathFileDataTransferObject.Put, StatePair<FieldProps['validationState']>> = {
        placePathId: useStatePair<FieldProps['validationState']>('none'),
        orderNumber: useStatePair<FieldProps['validationState']>('none'),
        fileName: useStatePair<FieldProps['validationState']>('none'),
        fileUrl: useStatePair<FieldProps['validationState']>('none'),
    }
    const putErrorState = useError()

    const onDoneClick = () => {
        inputValidationStates.placePathId.setValue('none')
        inputValidationStates.orderNumber.setValue('none')
        inputValidationStates.fileName.setValue('none')
        inputValidationStates.fileUrl.setValue('none')

        try {
            const dto: PlacePathFileDataTransferObject.Put = {
                placePathId: DataTransferObjectValidation.validate(PlacePathFileDataTransferObject.Put.validation, 'placePathId', inputStates.placePathId.value, () => inputValidationStates.placePathId.setValue('error')),
                orderNumber: DataTransferObjectValidation.validate(PlacePathFileDataTransferObject.Put.validation, 'orderNumber', inputStates.orderNumber.value, () => inputValidationStates.orderNumber.setValue('error')),
                fileName: DataTransferObjectValidation.validate(PlacePathFileDataTransferObject.Put.validation, 'fileName', inputStates.fileName.value, () => inputValidationStates.fileName.setValue('error')),
                fileUrl: DataTransferObjectValidation.validate(PlacePathFileDataTransferObject.Put.validation, 'fileUrl', inputStates.fileUrl.value, () => inputValidationStates.fileUrl.setValue('error')),
            }

            PlacePathFileIO.put(props.item.id, dto)
                .then((value) => {
                    const id = value.id.toString();
                    if(guideLineFile != null){
                        console.log(guideLineFile)
                        PlacePathFileIO.postFile(guideLineFile,id)
                            .then(value => {
                                const res = value
                                console.log(res)
                                if (!res) {
                                    alert('가이드라인 이미지 업로드에 실패했습니다.')
                                    return
                                }

                            })
                    }
                    window.alert('수정되었습니다.')
                })
                .catch(putErrorState.setDefinedValue)
        } catch (error) {
            console.error(error)
        }
    }

    return <>
        <putErrorState.Dialog {...props} />
        <Column gap={'16px'}>
            <Field
                className={styles.field}
                label={PlacePathFileDataTransferObject.Put.description.placePathId}
                validationState={inputValidationStates.placePathId.value}>
                <Input
                    value={inputStates.placePathId.value}
                    onChange={inputStates.placePathId.onChange} />
            </Field>
            <Field
                className={styles.field}
                label={PlacePathFileDataTransferObject.Put.description.orderNumber}
                validationState={inputValidationStates.orderNumber.value}>
                <Input
                    value={inputStates.orderNumber.value}
                    onChange={inputStates.orderNumber.onChange} />
            </Field>
            <Field
                className={styles.field}
                label={PlacePathFileDataTransferObject.Put.description.fileName}
                validationState={inputValidationStates.fileName.value}>
                <Input
                    value={inputStates.fileName.value}
                    onChange={inputStates.fileName.onChange} />
            </Field>
            <RadioGroup
                value={guideLineType}
                onChange={(_, data) => setGuideLineType(data.value)}

            >
                <div>
                    <Radio value="url" id="icon-url" />
                    <Label htmlFor="icon-url">URL 입력</Label>
                </div>
                <div>
                    <Radio value="file" id="icon-file" />
                    <Label htmlFor="icon-file">파일 업로드</Label>
                </div>
            </RadioGroup>
            {
                guideLineType == 'url' ?
                    <Field
                        className={styles.field}
                        label={ShoppingPathJointFileDataTransferObject.Put.description.fileUrl}
                        validationState={inputValidationStates.fileUrl.value}>
                        <Input
                            value={inputStates.fileUrl.value}
                            onChange={inputStates.fileUrl.onChange} />
                    </Field>
                    :
                    <>
                        <input type="file"
                               onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                                   if (event.target.files) {
                                       setGuideLineFile(event.target.files[0])
                                   }
                               }}
                               accept="image/*"
                        />


                    </>
            }
            {previewUrl && (
                <div>
                    <Image
                        src={previewUrl}
                        alt="가이드라인 이미지"
                        width={200}
                        height={200}
                    />
                </div>
            )}
            <Row>
                <Button
                    appearance={'primary'}
                    onClick={onDoneClick}>
                    완료
                </Button>
            </Row>
        </Column>
    </>
}